module.exports = __webpack_public_path__ + "img/card3.0eed8be4.png";